import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HomeNav from './HomeNav'
import Footer from './Footer'

const BRAND = '#6eb446'

const AboutUs: React.FC = () => {
  const { t } = useTranslation()

  useEffect(() => {
    document.body.classList.add('page-home')
    return () => document.body.classList.remove('page-home')
  }, [])

  const paragraphs = [1, 2, 3, 4, 5].map(i => t(`about_us.text${i}`))

  return (
    <>
      <HomeNav />

      {/* Hero */}
      <section style={{ backgroundColor: '#f8faf6', borderBottom: '4px solid #000', padding: '4rem 1.5rem 3rem' }}>
        <div style={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
          <span style={{
            display: 'inline-block',
            padding: '4px 16px',
            borderRadius: 9999,
            backgroundColor: '#e8f5dc',
            color: BRAND,
            fontSize: '0.78rem',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>
            Label Dictate
          </span>
          <h1 style={{
            margin: 0,
            fontSize: 'clamp(1.8rem, 5vw, 2.75rem)',
            fontWeight: 900,
            color: '#1e293b',
            letterSpacing: '-0.02em',
            lineHeight: 1.15,
          }}>
            {t('about_us.about')}
            <span style={{ color: BRAND }}>{t('about_us.us')}</span>
          </h1>
        </div>
      </section>

      {/* Intro callout */}
      <div style={{ backgroundColor: '#e8f5dc', borderBottom: '1px solid #c8edb0' }}>
        <div style={{ maxWidth: 760, margin: '0 auto', padding: '2.5rem 1.5rem' }}>
          <p style={{
            margin: 0,
            fontSize: 'clamp(1rem, 2vw, 1.15rem)',
            color: '#2d5a1b',
            lineHeight: 1.8,
            fontWeight: 500,
          }}>
            {t('about_us.text0')}
          </p>
        </div>
      </div>

      {/* Body */}
      <main style={{ backgroundColor: '#fff', padding: '3rem 1.5rem 5rem' }}>
        <div style={{ maxWidth: 760, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {paragraphs.map((text, i) => (
            <p key={i} style={{
              margin: 0,
              fontSize: '0.95rem',
              color: '#475569',
              lineHeight: 1.85,
              paddingBottom: '1.5rem',
              borderBottom: i < paragraphs.length - 1 ? '1px solid #f1f5f9' : 'none',
            }}>
              {text}
            </p>
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default AboutUs
